import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/illustration.png'
import _imports_1 from '@/assets/images/step1.png'
import _imports_2 from '@/assets/images/sunpay/step1.png'
import _imports_3 from '@/assets/images/step3.png'
import _imports_4 from '@/assets/images/sunpay/step3.png'
import _imports_5 from '@/assets/images/icon-copy.png'
import _imports_6 from '../../assets/images/bg-gery.png'


_pushScopeId("data-v-622ea231")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "ctx" }
const _hoisted_3 = { class: "brand" }
const _hoisted_4 = { class: "name font-bold" }
const _hoisted_5 = { class: "lang" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = {
  key: 0,
  class: "slogan animated fadeInLeft"
}
const _hoisted_9 = { class: "title font-bold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "illustration" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: "false"
}, null, -1)
const _hoisted_13 = { class: "desc" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "order" }
const _hoisted_16 = { class: "head" }
const _hoisted_17 = { class: "title font-bold" }
const _hoisted_18 = { class: "icon" }
const _hoisted_19 = {
  key: 0,
  src: _imports_1
}
const _hoisted_20 = {
  key: 1,
  src: _imports_2
}
const _hoisted_21 = { class: "tname" }
const _hoisted_22 = { class: "time" }
const _hoisted_23 = { class: "block" }
const _hoisted_24 = { class: "block" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1)
const _hoisted_26 = { class: "block" }
const _hoisted_27 = { class: "block" }
const _hoisted_28 = { class: "body" }
const _hoisted_29 = { class: "container" }
const _hoisted_30 = { class: "project" }
const _hoisted_31 = { class: "list" }
const _hoisted_32 = {
  key: 0,
  class: "item active"
}
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-622ea231><div class=\"icon\" data-v-622ea231><img src=\"/images/icon-logo.png\" alt=\"Klickl Pay\" data-v-622ea231></div><div class=\"value\" data-v-622ea231><div class=\"name\" data-v-622ea231>Klickl Pay</div></div></div>", 1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "item active"
}
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-622ea231><div class=\"icon\" data-v-622ea231><img src=\"/images/sunpay.png\" alt=\"Sun Pay\" data-v-622ea231></div><div class=\"value\" data-v-622ea231><div class=\"name\" data-v-622ea231>Sun Pay</div></div></div>", 1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "container" }
const _hoisted_39 = {
  key: 0,
  class: "project"
}
const _hoisted_40 = { class: "title" }
const _hoisted_41 = { class: "list" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "info" }
const _hoisted_44 = { class: "icon" }
const _hoisted_45 = ["src", "alt"]
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "name" }
const _hoisted_48 = {
  key: 1,
  class: "project"
}
const _hoisted_49 = { class: "title" }
const _hoisted_50 = { class: "list" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "info" }
const _hoisted_53 = { class: "icon" }
const _hoisted_54 = ["src", "alt"]
const _hoisted_55 = { class: "value" }
const _hoisted_56 = { class: "name" }
const _hoisted_57 = {
  key: 0,
  class: "desc"
}
const _hoisted_58 = {
  key: 0,
  class: "extend"
}
const _hoisted_59 = {
  key: 0,
  class: "footer"
}
const _hoisted_60 = { class: "total" }
const _hoisted_61 = {
  key: 0,
  class: "item"
}
const _hoisted_62 = { class: "value" }
const _hoisted_63 = { class: "item" }
const _hoisted_64 = { class: "number font-bold" }
const _hoisted_65 = { class: "action font-bold" }
const _hoisted_66 = { class: "pay" }
const _hoisted_67 = { class: "head" }
const _hoisted_68 = { class: "title font-bold" }
const _hoisted_69 = { class: "icon" }
const _hoisted_70 = {
  key: 0,
  src: _imports_3
}
const _hoisted_71 = {
  key: 1,
  src: _imports_4
}
const _hoisted_72 = { class: "desc" }
const _hoisted_73 = { class: "body" }
const _hoisted_74 = { class: "container" }
const _hoisted_75 = {
  key: 0,
  class: "form"
}
const _hoisted_76 = {
  key: 0,
  class: "item full"
}
const _hoisted_77 = { class: "label" }
const _hoisted_78 = { class: "value" }
const _hoisted_79 = {
  key: 1,
  class: "item full"
}
const _hoisted_80 = { class: "label" }
const _hoisted_81 = { class: "value" }
const _hoisted_82 = {
  key: 2,
  class: "item full"
}
const _hoisted_83 = { class: "label" }
const _hoisted_84 = { class: "value" }
const _hoisted_85 = { class: "search" }
const _hoisted_86 = { class: "input" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = {
  key: 3,
  class: "item full"
}
const _hoisted_89 = { class: "label" }
const _hoisted_90 = { class: "value" }
const _hoisted_91 = {
  key: 4,
  class: "item full"
}
const _hoisted_92 = { class: "label" }
const _hoisted_93 = { class: "value" }
const _hoisted_94 = {
  key: 5,
  class: "item full"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "CVV", -1)
const _hoisted_96 = { class: "value" }
const _hoisted_97 = {
  key: 6,
  class: "item full"
}
const _hoisted_98 = { class: "label" }
const _hoisted_99 = { class: "value" }
const _hoisted_100 = {
  key: 1,
  class: "result"
}
const _hoisted_101 = {
  key: 0,
  class: "project"
}
const _hoisted_102 = { class: "amount font-bold" }
const _hoisted_103 = { class: "desc" }
const _hoisted_104 = { class: "qrcode" }
const _hoisted_105 = { class: "subtitle" }
const _hoisted_106 = { class: "paycode" }
const _hoisted_107 = { class: "input border" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = { class: "subtitle" }
const _hoisted_111 = { class: "paycode" }
const _hoisted_112 = { class: "input border" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { class: "tips" }
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { class: "footer" }
const _hoisted_119 = { class: "action font-bold" }
const _hoisted_120 = {
  key: 1,
  class: "status"
}
const _hoisted_121 = {
  key: 0,
  class: "loader"
}
const _hoisted_122 = { class: "icon" }
const _hoisted_123 = ["src", "alt"]
const _hoisted_124 = { class: "name" }
const _hoisted_125 = { class: "amount" }
const _hoisted_126 = { class: "infos" }
const _hoisted_127 = { class: "label" }
const _hoisted_128 = { class: "value" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_130 = [
  _hoisted_129
]
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { class: "label" }
const _hoisted_133 = { class: "value" }
const _hoisted_134 = {
  key: 0,
  class: "channel"
}
const _hoisted_135 = ["src", "alt"]
const _hoisted_136 = { key: 1 }
const _hoisted_137 = { class: "label" }
const _hoisted_138 = { class: "value" }
const _hoisted_139 = { key: 2 }
const _hoisted_140 = { class: "label" }
const _hoisted_141 = { class: "value" }
const _hoisted_142 = { key: 3 }
const _hoisted_143 = { class: "label" }
const _hoisted_144 = { class: "value" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = { key: 4 }
const _hoisted_148 = { class: "label" }
const _hoisted_149 = { class: "value" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = { key: 5 }
const _hoisted_153 = { class: "label" }
const _hoisted_154 = { class: "value links" }
const _hoisted_155 = ["href"]
const _hoisted_156 = { class: "value full" }
const _hoisted_157 = { key: 0 }
const _hoisted_158 = { class: "tips" }
const _hoisted_159 = { key: 0 }
const _hoisted_160 = { key: 1 }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("li", { class: "line" }, null, -1)
const _hoisted_162 = { key: 7 }
const _hoisted_163 = { class: "label" }
const _hoisted_164 = { class: "value" }
const _hoisted_165 = { class: "item" }
const _hoisted_166 = { class: "label" }
const _hoisted_167 = { class: "value" }
const _hoisted_168 = {
  key: 1,
  class: "action"
}
const _hoisted_169 = { class: "btn" }
const _hoisted_170 = ["action"]
const _hoisted_171 = ["value"]
const _hoisted_172 = ["value"]
const _hoisted_173 = ["value"]
const _hoisted_174 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "ipAddress",
  value: "119.8.190.19"
}, null, -1)
const _hoisted_175 = ["value"]
const _hoisted_176 = ["value"]
const _hoisted_177 = ["value"]
const _hoisted_178 = ["value"]
const _hoisted_179 = {
  key: 1,
  class: "iframe"
}
const _hoisted_180 = ["src"]
const _hoisted_181 = { class: "copyright" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:business@klicklpay.com" }, "business@klicklpay.com", -1)
const _hoisted_183 = {
  key: 0,
  class: "background"
}
const _hoisted_184 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "background"
}, null, -1)
const _hoisted_185 = [
  _hoisted_184
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["klickl-pay-cashier", [_ctx.data.dev]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("cashier.h1")), 1)
        ]),
        _createVNode(_component_van_popover, {
          show: _ctx.showPopover,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
          actions: _ctx.data.Languages,
          theme: "dark",
          onSelect: _ctx.changeLang
        }, {
          reference: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("img", {
                src: `/images/${_ctx.locale}.png`,
                alt: _ctx.locale
              }, null, 8, _hoisted_6),
              _createTextVNode(_toDisplayString(_ctx.getLangName), 1)
            ])
          ]),
          _: 1
        }, 8, ["show", "actions", "onSelect"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_i18n_t, {
                keypath: "cashier.payin",
                scope: "global"
              }, {
                br: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_i18n_t, {
                  keypath: "cashier.tip1",
                  scope: "global"
                }, {
                  br: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["payment", { ordered: _ctx.data.FormData.orderStatus !== 0 }])
      }, [
        (_ctx.data.FormData.orderStatus == 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["infos", { nexts: _ctx.step > 1 || _ctx.result }])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                        : (_openBlock(), _createElementBlock("img", _hoisted_20))
                    ]),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("cashier.paytype")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    false
                      ? (_openBlock(), _createBlock(_component_van_count_down, {
                          key: 0,
                          time: Number(_ctx.data.FormData.expiresIn) * 1000,
                          format: "mm:ss",
                          onFinish: _ctx.finish
                        }, {
                          default: _withCtx((timeData) => [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.splitNumber(timeData.minutes)[0]), 1),
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.splitNumber(timeData.minutes)[1]), 1),
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.splitNumber(timeData.seconds)[0]), 1),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.splitNumber(timeData.seconds)[1]), 1)
                          ]),
                          _: 1
                        }, 8, ["time", "onFinish"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                          : (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                      ])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_38, [
                    (_ctx.CashChannelList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("cashier.payment")), 1),
                          _createElementVNode("div", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CashChannelList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: item.code == _ctx.data.FormData.channelCode }]),
                                key: item.code,
                                onClick: 
                        () => {
                          _ctx.data.FormData.channelCode = item.code;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("img", {
                                      src: item.icon,
                                      alt: item.code
                                    }, null, 8, _hoisted_45)
                                  ]),
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, _toDisplayString(item.name), 1)
                                  ])
                                ])
                              ], 10, _hoisted_42))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.PaymentTypeList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t("cashier.paytype")), 1),
                          _createElementVNode("div", _hoisted_50, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PaymentTypeList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: _ctx.data.FormData.paymentType == item.supportedChannelType }]),
                                key: item.id,
                                onClick: 
                        () => {
                          _ctx.data.FormData.paymentType = item.supportedChannelType;
                          _ctx.data.FormData.transactionFee = item.transactionFee;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("img", {
                                      src: 
                              _ctx.data.InterfaceUI[item.supportedChannelType]?.icon ||
                                '~@/assets/images/icon-other.png'
                            ,
                                      alt: item.supportedChannelType
                                    }, null, 8, _hoisted_54)
                                  ]),
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("div", _hoisted_56, _toDisplayString(item.supportedChannelType), 1),
                                    false
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.data.InterfaceUI[item.supportedChannelType]?.name ||
                                _ctx.$t("cashier.other")), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                false
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.$t("cashier.fee")) + ": " + _toDisplayString(item.transactionFee), 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_51))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, false]
                  ]),
                  (_ctx.CashChannelList?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                                _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.data.FormData.transactionFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.total")), 1),
                            _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          (_ctx.data.FormData.cancelUrl)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "btn cancel",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                              }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "btn next",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps.length ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_70))
                        : (_openBlock(), _createElementBlock("img", _hoisted_71))
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.scan")) + " " + _toDisplayString(_ctx.$t("cashier.payinfo")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t("cashier.desc")), 1)
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    (!_ctx.result)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          (_ctx.forms.supplier)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t("cashier.supplier")), 1),
                                _createElementVNode("div", _hoisted_78, [
                                  _createVNode(_component_van_cell, {
                                    "is-link": "",
                                    icon: "birthday-cake-o",
                                    title: 
                            _ctx.getNameByCode(_ctx.data.FormData.supplier, _ctx.SupplierList) || _ctx.$t('choose')
                          ,
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSupplierSheet = true))
                                  }, null, 8, ["title"]),
                                  _createVNode(_component_van_action_sheet, {
                                    show: _ctx.showSupplierSheet,
                                    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSupplierSheet = $event)),
                                    actions: _ctx.SupplierList,
                                    onSelect: _ctx.onSelectSupplier,
                                    description: _ctx.$t('choose'),
                                    "cancel-text": _ctx.$t('cancel'),
                                    "close-on-click-action": ""
                                  }, null, 8, ["show", "actions", "onSelect", "description", "cancel-text"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.phoneNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t("cashier.phone")), 1),
                                _createElementVNode("div", _hoisted_81, [
                                  _createVNode(_component_van_field, {
                                    label: ``,
                                    placeholder: _ctx.$t('cashier.phone'),
                                    modelValue: _ctx.data.FormData.phoneNumber,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.data.FormData.phoneNumber = $event)),
                                    "left-icon": "phone-o",
                                    maxlength: "30",
                                    type: "digit",
                                    "right-icon": _ctx.data.FormData.phoneNumber && 'clear',
                                    onClickRightIcon: _cache[6] || (_cache[6] = 
                            () => {
                              _ctx.data.FormData.phoneNumber = '';
                            }
                          )
                                  }, null, 8, ["placeholder", "modelValue", "right-icon"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.bankCode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t("cashier.bank")), 1),
                                _createElementVNode("div", _hoisted_84, [
                                  _createVNode(_component_van_cell, {
                                    "is-link": "",
                                    icon: "wap-home-o",
                                    title: _ctx.getNameByCode(_ctx.data.FormData.bankCode, _ctx.BankList) || _ctx.$t('choose'),
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showBankSheet = true))
                                  }, null, 8, ["title"]),
                                  false
                                    ? (_openBlock(), _createBlock(_component_van_action_sheet, {
                                        key: 0,
                                        show: _ctx.showBankSheet,
                                        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showBankSheet = $event)),
                                        actions: _ctx.BankList,
                                        onSelect: _ctx.onSelectBank,
                                        description: _ctx.$t('choose'),
                                        "cancel-text": _ctx.$t('cancel'),
                                        "close-on-click-action": ""
                                      }, null, 8, ["show", "actions", "onSelect", "description", "cancel-text"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_van_action_sheet, {
                                    show: _ctx.showBankSheet,
                                    "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_ctx.showBankSheet = $event)),
                                    description: _ctx.$t('choose'),
                                    "cancel-text": _ctx.$t('cancel'),
                                    "close-on-click-action": "",
                                    class: "bank-select"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_85, [
                                        _createElementVNode("div", _hoisted_86, [
                                          _createVNode(_component_van_field, {
                                            label: ``,
                                            placeholder: "Search",
                                            modelValue: _ctx.data.Search.bank,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.data.Search.bank = $event)),
                                            "left-icon": "search",
                                            "right-icon": _ctx.data.Search.bank && 'clear',
                                            onClickRightIcon: _cache[10] || (_cache[10] = 
                                  () => {
                                    _ctx.data.Search.bank = '';
                                  }
                                )
                                          }, null, 8, ["modelValue", "right-icon"])
                                        ])
                                      ]),
                                      _createElementVNode("ul", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BankList, (item) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: item.value,
                                            onClick: ($event: any) => (_ctx.onSelectBank(item))
                                          }, _toDisplayString(item.name), 9, _hoisted_87))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["show", "description", "cancel-text"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.bankNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.data.FormData.paymentType == "CREDITCARD"
                            ? _ctx.$t("cashier.cardNumber")
                            : _ctx.$t("cashier.bankNumber")), 1),
                                _createElementVNode("div", _hoisted_90, [
                                  _createVNode(_component_van_field, {
                                    label: ``,
                                    modelValue: _ctx.data.FormData.bankNumber,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.data.FormData.bankNumber = $event)),
                                    maxlength: "30",
                                    type: "digit",
                                    placeholder: 
                            _ctx.data.FormData.paymentType == 'CREDITCARD'
                              ? _ctx.$t('cashier.cardNumber')
                              : _ctx.$t('cashier.bankNumber')
                          ,
                                    "left-icon": "credit-pay",
                                    "right-icon": _ctx.data.FormData.bankNumber && 'clear',
                                    onClickRightIcon: _cache[13] || (_cache[13] = 
                            () => {
                              _ctx.data.FormData.bankNumber = '';
                            }
                          )
                                  }, null, 8, ["modelValue", "placeholder", "right-icon"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.expiryDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t("cashier.expiryDate")), 1),
                                _createElementVNode("div", _hoisted_93, [
                                  _createVNode(_component_van_field, {
                                    "is-link": "",
                                    readonly: "",
                                    name: "calendar",
                                    "left-icon": "clock-o",
                                    label: '',
                                    placeholder: `MM/YY`,
                                    modelValue: _ctx.data.FormData.expiryDate,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.data.FormData.expiryDate = $event)),
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showCalendar = true))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_van_action_sheet, {
                                    show: _ctx.showCalendar,
                                    "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => (_ctx.showCalendar = $event)),
                                    title: _ctx.$t('cashier.datetime')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_van_datetime_picker, {
                                        "confirm-button-text": _ctx.$t('complete'),
                                        "cancel-button-text": _ctx.$t('cancel'),
                                        "columns-order": ['month', 'year'],
                                        "min-date": _ctx.data.minData,
                                        type: "year-month",
                                        onCancel: _cache[16] || (_cache[16] = 
                              () => {
                                _ctx.data.FormData.expiryDate = '';
                                _ctx.showCalendar = false;
                              }
                            ),
                                        onConfirm: _ctx.onDateTimePickerHandler
                                      }, null, 8, ["confirm-button-text", "cancel-button-text", "min-date", "onConfirm"])
                                    ]),
                                    _: 1
                                  }, 8, ["show", "title"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.cvv)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                _hoisted_95,
                                _createElementVNode("div", _hoisted_96, [
                                  _createVNode(_component_van_field, {
                                    label: ``,
                                    modelValue: _ctx.data.FormData.cvv,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.data.FormData.cvv = $event)),
                                    placeholder: "CVV",
                                    "left-icon": "coupon-o",
                                    type: "digit",
                                    maxlength: "3",
                                    "right-icon": _ctx.data.FormData.cvv && 'clear',
                                    onClickRightIcon: _cache[19] || (_cache[19] = 
                            () => {
                              _ctx.data.FormData.cvv = '';
                            }
                          )
                                  }, null, 8, ["modelValue", "right-icon"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.step == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.$t("cashier.accountName")), 1),
                                _createElementVNode("div", _hoisted_99, [
                                  _createVNode(_component_van_field, {
                                    modelValue: _ctx.data.FormData.accountName,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.data.FormData.accountName = $event)),
                                    "left-icon": "user-o",
                                    disabled: "",
                                    label: ``
                                  }, null, 8, ["modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_100, [
                          (
                        ['AlchemyPay'].includes(_ctx.data.FormData.channelCode) &&
                          ['QRIS', 'OVO', 'DIRECT'].includes(_ctx.data.FormData.paymentType)
                      )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                _createElementVNode("div", _hoisted_102, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("cashier.pay")) + " ", 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                                ]),
                                _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.$t("cashier.qrcode")), 1),
                                _createElementVNode("div", _hoisted_104, [
                                  _createVNode(_component_VueQrcode, {
                                    value: 
                            _ctx.data.FormData.paymentType == 'QRIS'
                              ? _ctx.data.FormData.extend.qrCode
                              : _ctx.data.FormData.extend.paymentCode || _ctx.data.FormData.extend.vaNumber
                          ,
                                    tag: "img",
                                    options: {
                            width: 180,
                            margin: 0
                          }
                                  }, null, 8, ["value"])
                                ]),
                                (_ctx.data.FormData.extend.paymentCode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.$t("cashier.paymentCode")), 1),
                                      _createElementVNode("div", _hoisted_106, [
                                        _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.data.FormData.extend.paymentCode || ""), 1),
                                        _createElementVNode("div", {
                                          class: "extend border",
                                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.copy(_ctx.data.FormData.extend.paymentCode)))
                                        }, _hoisted_109)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.data.FormData.extend.vaNumber)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.$t("cashier.vaNumber")), 1),
                                      _createElementVNode("div", _hoisted_111, [
                                        _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.data.FormData.extend.vaNumber || ""), 1),
                                        _createElementVNode("div", {
                                          class: "extend border",
                                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.copy(_ctx.data.FormData.extend.vaNumber)))
                                        }, _hoisted_114)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_115, [
                                  (_ctx.data.FormData.paymentType == 'DIRECT')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_116, _toDisplayString(_ctx.$t("cashier.useBank", { name: _ctx.data.FormData.bankName })), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.data.FormData.paymentType == 'QRIS')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_117, _toDisplayString(_ctx.$t("cashier.useQRIS", { name: _ctx.data.FormData.paymentType })), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn cancel",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.nextStep(false)))
                          }, _toDisplayString(_ctx.$t("cashier.back")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.result && _ctx.data.FormData.cancelUrl)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "btn cancel",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                          }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["btn next", { disabled: _ctx.isDisableConfirm }]),
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps.length ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 3))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        ([1, 2, 3, 4].includes(_ctx.data.FormData.orderStatus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
              (_ctx.data.FormData.orderStatus == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_121))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("img", {
                  src: `/images/status/${_ctx.CashPayInOrderStatus[_ctx.data.FormData.orderStatus]}.png`,
                  alt: _ctx.CashPayInOrderStatus[_ctx.data.FormData.orderStatus]
                }, null, 8, _hoisted_123)
              ]),
              _createElementVNode("div", _hoisted_124, [
                _createTextVNode(_toDisplayString(_ctx.$t(`cashier.PayinStatus[${_ctx.data.FormData.orderStatus}]`)) + " ", 1),
                _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.data.FormData.currency) + " " + _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_127, _toDisplayString(_ctx.$t("cashier.orderNo")), 1),
                    _createElementVNode("div", _hoisted_128, [
                      _createTextVNode(_toDisplayString(_ctx.data.FormData.outOrderNo) + " ", 1),
                      _createElementVNode("span", {
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.copy(_ctx.data.FormData.outOrderNo)))
                      }, _hoisted_130)
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_131, [
                        _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t("cashier.channel")), 1),
                        _createElementVNode("div", _hoisted_133, [
                          (_ctx.data.FormData.channelIcon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                _createElementVNode("img", {
                                  src: _ctx.data.FormData.channelIcon,
                                  alt: _ctx.data.FormData.channelName
                                }, null, 8, _hoisted_135)
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.data.FormData.channelName || "--"), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.accountType)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_136, [
                        _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.$t("cashier.paymentType")), 1),
                        _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.data.FormData.accountType), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.bankName)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.$t("cashier.bank")), 1),
                        _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.data.FormData.bankName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.paymentCode)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.$t("cashier.paymentCode")), 1),
                        _createElementVNode("div", _hoisted_144, [
                          _createTextVNode(_toDisplayString(_ctx.data.FormData.paymentCode) + " ", 1),
                          _createElementVNode("span", {
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.copy(_ctx.data.FormData.paymentCode)))
                          }, _hoisted_146)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.vaNumber)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.$t("cashier.vaNumber")), 1),
                        _createElementVNode("div", _hoisted_149, [
                          _createTextVNode(_toDisplayString(_ctx.data.FormData.vaNumber) + " ", 1),
                          _createElementVNode("span", {
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.copy(_ctx.data.FormData.vaNumber)))
                          }, _hoisted_151)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                  _ctx.data.FormData.orderStatus == 1 &&
                    _ctx.data.FormData.checkoutUrl &&
                    _ctx.data.FormData.channelName !== 'LinkedPay'
                )
                    ? (_openBlock(), _createElementBlock("li", _hoisted_152, [
                        _createElementVNode("div", _hoisted_153, _toDisplayString(_ctx.$t("cashier.link")), 1),
                        _createElementVNode("div", _hoisted_154, [
                          (_ctx.from == 'app')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "a",
                                onClick: _cache[29] || (_cache[29] = 
                      () => {
                        _ctx.iframeUrl = _ctx.data.FormData.checkoutUrl;
                      }
                    )
                              }, _toDisplayString(_ctx.$t("cashier.pay")), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: _ctx.data.FormData.checkoutUrl,
                                target: "_self"
                              }, _toDisplayString(_ctx.$t("cashier.pay")), 9, _hoisted_155))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.qrCode || _ctx.data.FormData.paymentCode || _ctx.data.FormData.vaNumber)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_156, [
                            _createVNode(_component_VueQrcode, {
                              value: 
                        _ctx.data.FormData.accountType == 'QRIS'
                          ? _ctx.data.FormData.qrCode
                          : _ctx.data.FormData.paymentCode || _ctx.data.FormData.vaNumber
                      ,
                              tag: "img",
                              options: {
                        width: 140,
                        margin: 0
                      }
                            }, null, 8, ["value"])
                          ])
                        ]),
                        (_ctx.data.FormData.orderStatus == 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_157, [
                              _createElementVNode("div", _hoisted_158, [
                                (_ctx.data.FormData.accountType == 'DIRECT')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_159, _toDisplayString(_ctx.$t("cashier.useBank", { name: _ctx.data.FormData.bankName })), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.data.FormData.accountType == 'QRIS')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_160, _toDisplayString(_ctx.$t("cashier.useQRIS", { name: _ctx.data.FormData.accountType })), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  _hoisted_161,
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_162, [
                        _createElementVNode("div", _hoisted_163, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                        _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.data.FormData.serviceFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_165, [
                    _createElementVNode("div", _hoisted_166, _toDisplayString(_ctx.$t("cashier.orderTime")), 1),
                    _createElementVNode("div", _hoisted_167, _toDisplayString(_ctx.FormatDateZone(_ctx.data.FormData.creationAt) || "--"), 1)
                  ])
                ])
              ]),
              (_ctx.data.FormData.orderStatus == 1 && false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, _toDisplayString(_ctx.$t("cashier.paid")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.FormData.channelCode === 'LinkedPay')
          ? (_openBlock(), _createElementBlock("form", {
              key: 2,
              ref: "LinkedPayForm",
              action: _ctx.data.FormData.extend.checkoutUrl,
              method: "post",
              target: "_self"
            }, [
              _createElementVNode("input", {
                type: "hidden",
                name: "merchantNo",
                value: _ctx.data.FormData.extend.merchantNo
              }, null, 8, _hoisted_171),
              _createElementVNode("input", {
                type: "hidden",
                name: "merOrderNo",
                value: _ctx.data.FormData.extend.orderNo
              }, null, 8, _hoisted_172),
              _createElementVNode("input", {
                type: "hidden",
                name: "notifyUrl",
                value: _ctx.data.FormData.extend.notifyUrl
              }, null, 8, _hoisted_173),
              _hoisted_174,
              _createElementVNode("input", {
                type: "hidden",
                name: "currencyCode",
                value: _ctx.data.FormData.currency
              }, null, 8, _hoisted_175),
              _createElementVNode("input", {
                type: "hidden",
                name: "amount",
                value: _ctx.data.FormData.amount
              }, null, 8, _hoisted_176),
              _createElementVNode("input", {
                type: "hidden",
                name: "returnUrl",
                value: 
                `${
                  _ctx.data.FormData.extend.syncNotifyUrl
                }${`${_ctx.data.path}/cashier/payin?k=${_ctx.data.token}`}`
              
              }, null, 8, _hoisted_177),
              _createElementVNode("input", {
                type: "hidden",
                name: "websiteUrl",
                value: _ctx.data.path
              }, null, 8, _hoisted_178)
            ], 8, _hoisted_170))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.iframeUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.iframeUrl = ''))
            }, "Χ"),
            _createElementVNode("iframe", {
              src: _ctx.iframeUrl,
              frameborder: "0",
              name: "iframeUrl",
              id: "myIframe",
              seamless: ""
            }, null, 8, _hoisted_180)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_181, [
      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
        ? (_openBlock(), _createBlock(_component_i18n_t, {
            key: 0,
            keypath: "cashier.copyright",
            scope: "global"
          }, {
            mail: _withCtx(() => [
              _hoisted_182
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
      ? (_openBlock(), _createElementBlock("div", _hoisted_183, _hoisted_185))
      : _createCommentVNode("", true)
  ], 2))
}